var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[(_vm.$store.getters.partages)?_c('partage'):_vm._e()],1),_c('div',{staticClass:"column is-4"},[_c('partages')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }